import React from "react";
import Table, { KebabMenu } from "../../../components/Common/Table";
import Button from "../../../components/Common/Button";
import { customerTableColumns, CUSTOMERS_PAGE_TITLE } from "../dataFiles/customersPageDataFile";

export default function CustomerTable({ customers = [], branchName, onSelect, onEdit, onDelete, onAddCustomer, activeCustomerEmail, canEdit = false, canDelete = false }) {
  const columns = [
    ...customerTableColumns,
    {
      key: "actions",
      header: "Actions",
      align: "right",
      width: "80px",
      render: (row) => (
        <div className="wg-table__actions">
          <KebabMenu
            items={[
              { label: "Edit", onClick: () => onEdit(row), disabled: !canEdit },
              { label: "Delete", onClick: () => onDelete(row), disabled: !canDelete },
            ]}
          />
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      data={customers}
      rowKey="email"
      activeRowKey={activeCustomerEmail}
      hoverable
      onRowClick={onSelect}
      emptyState="No customers found for this branch."
      toolbar={{
        left: (
          <div>
            <h2 className="wg-page-header">{CUSTOMERS_PAGE_TITLE}</h2>
            {branchName && (
              <p style={{ fontSize: "13px", color: "#64748b", margin: "4px 0 0 0" }}>
                {branchName} &middot; {customers.length} {customers.length === 1 ? "customer" : "customers"}
              </p>
            )}
          </div>
        ),
        right: onAddCustomer && (
          <Button onClick={onAddCustomer}>+ New Customer</Button>
        ),
      }}
    />
  );
}
